import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatCurrencyBRL = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(toNumber(value));
};

const getBarColor = (lucro) => {
  if (lucro > 0) return '#52c41a';
  if (lucro < 0) return '#ff4d4f';
  return '#bfbfbf';
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const row = payload[0].payload;

  return (
    <div style={{ background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, padding: 10 }}>
      <div><strong>{row?.turma_nome || '-'}</strong></div>
      <div>Modalidade: {row?.modalidade || '-'}</div>
      <div>Receita: {formatCurrencyBRL(row?.receita)}</div>
      <div>Custo Professor: {formatCurrencyBRL(row?.custo_professor)}</div>
      <div style={{ color: getBarColor(toNumber(row?.lucro)) }}>
        Lucro: {formatCurrencyBRL(row?.lucro)}
      </div>
    </div>
  );
};

const LucroTurmaChartV2 = ({ data }) => {
  const sortedData = [...(data || [])].sort((a, b) => toNumber(b?.lucro) - toNumber(a?.lucro));
  const useTiltedLabels = sortedData.length > 6;

  return (
    <ResponsiveContainer width="100%" height={360}>
      <BarChart data={sortedData} margin={{ top: 12, right: 24, left: 8, bottom: useTiltedLabels ? 72 : 36 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="turma_nome"
          interval={0}
          angle={useTiltedLabels ? -30 : 0}
          textAnchor={useTiltedLabels ? 'end' : 'middle'}
          height={useTiltedLabels ? 72 : 36}
        />
        <YAxis tickFormatter={(value) => formatCurrencyBRL(value)} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="lucro" name="Lucro">
          {sortedData.map((entry, idx) => (
            <Cell key={`lucro-turma-cell-${idx}`} fill={getBarColor(toNumber(entry?.lucro))} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default LucroTurmaChartV2;
